// The structure tree (prototype `tree`): the transaction, each form, its
// "Decided by" and "Combinations", and each attribute set with its column
// count. Selecting a node moves the step bar.

import { FileText, Grid2x2, KeyRound, Layers } from 'lucide-react'
import { tw } from '../../testHooks'
import { formOf } from './model'
import { useSetup } from './state'
import { SetDot } from './ui'

export default function SetupTree() {
  const { forms, formNo, setFormNo, node, go, draft } = useSetup()
  return (
    <>
      <button type="button" className={`uds-tn ${node.t === 'root' ? 'on' : ''}`} onClick={() => go({ t: 'root' })}>
        <FileText size={16} /><span className="t">{forms[0]?.title || 'Transaction'}</span>
        <span className="m">{forms.length} form{forms.length === 1 ? '' : 's'}</span>
      </button>
      {forms.map(f => {
        const lf = formOf(draft.layer, f.formNo)
        const here = formNo === f.formNo
        const pick = (n: Parameters<typeof go>[0]) => { setFormNo(f.formNo); go(n) }
        return (
          <div key={f.formNo} style={{ display: 'contents' }}>
            <button type="button" className="uds-tn l1" onClick={() => pick({ t: 'root' })}
              {...tw('action', `uda-form:${f.formNo}`)}>
              <FileText size={16} /><span className="t">{f.title}</span>
              <span className="m uds-mono">{f.table}</span>
            </button>
            <button type="button" className={`uds-tn l2 ${here && node.t === 'decide' ? 'on' : ''}`}
              onClick={() => pick({ t: 'decide' })}>
              <KeyRound size={15} /><span className="t">Decided by</span><span className="m">{lf?.drivers?.length || 0}</span>
            </button>
            <button type="button" className={`uds-tn l2 ${here && node.t === 'combos' ? 'on' : ''}`}
              onClick={() => pick({ t: 'combos' })}>
              <Grid2x2 size={15} /><span className="t">Combinations</span><span className="m">{lf?.sets?.length || 0}</span>
            </button>
            {(lf?.sets || []).map(s => {
              const on = here && (node.t === 'set' || node.t === 'col') && node.set === s.key
              return (
                <button key={s.key} type="button" className={`uds-tn l3 ${on ? 'on' : ''}`}
                  onClick={() => pick({ t: 'set', set: s.key })}>
                  <Layers size={14} /><SetDot color={s.color} size={8} />
                  <span className="t">{s.label || s.key}</span><span className="m">{(s.columns || []).length}</span>
                </button>
              )
            })}
          </div>
        )
      })}
    </>
  )
}
